import React from 'react'
import { Typography } from '@material-ui/core'
import Price from './Price'
import clsx from 'clsx'
import { useStyles } from '../Packs/PacksCard'

type TProps = {
  data: any
  amount: number
  showDayOrMonth?: boolean
}

const PackPrice = ({ data, amount, showDayOrMonth = true }: TProps) => {
  const classes = useStyles()
  return (
    <Typography
      variant={'h3'}
      className={clsx('pack__price', classes.whiteSpace)}
      component={'span'}
    >
      <Price
        amount={amount}
        showDayOrMonth={showDayOrMonth}
        isShort={false}
        dayOrMonth={data?.day_or_month}
        dayOrMonthShort={data?.day_or_month_short}
        displayFlexPrice={data?.display_flex_price_a_day}
      />
    </Typography>
  )
}

export default PackPrice
